const states = [
    { "value": 'andhra pradesh', "label": 'Andhra Pradesh' },
    { "value": 'arunachal pradesh', "label": 'Arunachal Pradesh' },
    { "value": 'assam', "label": 'Assam' },
    { "value": 'bihar', "label": 'Bihar' },
    { "value": 'chhattisgarh', "label": 'Chhattisgarh' },
    { "value": 'goa', "label": 'Goa' },
    { "value": 'gujarat', "label": 'Gujarat' },
    { "value": 'haryana', "label": 'Haryana' },
    { "value": 'himachal pradesh', "label": 'Himachal Pradesh' },
    { "value": 'jharkhand', "label": 'Jharkhand' },
    { "value": 'karnataka', "label": 'Karnataka' },
    { "value": 'kerala', "label": 'Kerala' },
    { "value": 'madhya pradesh', "label": 'Madhya Pradesh' },
    { "value": 'maharashtra', "label": 'Maharashtra' },
    { "value": 'manipur', "label": 'Manipur' },
    { "value": 'meghalaya', "label": 'Meghalaya' },
    { "value": 'mizoram', "label": 'Mizoram' },
    { "value": 'nagaland', "label": 'Nagaland' },
    { "value": 'odisha', "label": 'Odisha' },
    { "value": 'punjab', "label": 'Punjab' },
    { "value": 'rajasthan', "label": 'Rajasthan' },
    { "value": 'sikkim', "label": 'Sikkim' },
    { "value": 'tamil nadu', "label": 'Tamil Nadu' },
    { "value": 'telangana', "label": 'Telangana' },
    { "value": 'tripura', "label": 'Tripura' },
    { "value": 'uttarakhand', "label": 'Uttarakhand' },
    { "value": 'uttar pradesh', "label": 'Uttar Pradesh' },
    { "value": 'west bengal', "label": 'West Bengal' },
    { "value": 'andaman and nicobar islands', "label": 'Andaman and Nicobar Islands' },
    { "value": 'chandigarh', "label": 'Chandigarh' },
    { "value": 'dadra and nagar haveli and daman and diu', "label": 'Dadra and Nagar Haveli and Daman and Diu' },
    { "value": 'delhi', "label": 'Delhi' },
    { "value": 'jammu and kashmir', "label": 'Jammu and Kashmir' },
    { "value": 'ladakh', "label": 'Ladakh' },
    { "value": 'lakshadweep', "label": 'Lakshadweep' },
    { "value": 'puducherry', "label": 'Puducherry' },
    { "value": 'Other', "label": 'Other'}
];

export default states
